// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".def-img[data-v-78c7dc3c]{display:block;height:auto;width:100%}", "",{"version":3,"sources":["webpack://./js.autoload/vueComponents/Def/DefImg/DefImg.vue"],"names":[],"mappings":"AAAA,0BAAS,aAAA,CAAc,WAAA,CAAY,UAInC","sourcesContent":[".def-img{display:block;height:auto;width:100%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
